import styled from '@emotion/styled'
import { Button, InputField } from '@gousto-internal/citrus-react'
import { applyPromoCode } from '@library/api-user'
import { Field, Form, FieldProps, useFormik, FormikProvider } from 'formik'
import React from 'react'

const PromoFormRow = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  align-items: flex-end;
`

const StyledInputField = styled(InputField)`
  min-width: 328px;
  margin: 0;
`

const StyledButton = styled(Button)`
  margin-left: 8px;
  margin-bottom: 8px;
  height: 48px;
  min-width: 148px;
`

export const PromoCodeSection = () => {
  const formik = useFormik({
    initialValues: {
      promocode: '',
    },
    onSubmit: async (value) => {
      try {
        await applyPromoCode(value.promocode)
      } catch (error) {
        console.error('Error applying promo code:', error)
      }
    },
  })

  return (
    <FormikProvider value={formik}>
      <Form>
        <PromoFormRow>
          <Field
            name="promocode"
            type="text"
            placeholder="Enter your promo code"
            data-testid="promoCodeInput"
          >
            {({ field }: FieldProps) => (
              <StyledInputField
                id="promocode"
                label={null}
                placeholder="Enter your promo code"
                autoComplete="off"
                {...field}
              />
            )}
          </Field>
          <StyledButton type="submit">Enter code</StyledButton>
        </PromoFormRow>
      </Form>
    </FormikProvider>
  )
}
